import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SwitchTransition } from 'react-transition-group';
import cx from 'classnames';

import Animation from 'components/Animation';

import CommonPropTypes from 'utils/propTypes/common';

import BroadcastPreview from './components/BroadcastPreview';
import MoviePreview from './components/MoviePreview';

import styles from './styles.module.scss';
import RecommendationsSlider from './components/Slider';

const Recommendations = ({
	recommendations,
	personalRecommendations,
	type,
	title,
	markupBlocks,
	renderCard,
	...props
}) => {
	const [activeEntity, setActiveEntity] = useState(recommendations[0]);
	const [showVideo, setShowVideo] = useState(null);

	const Preview = type === 'broadcast' ? BroadcastPreview : MoviePreview;

	const videoCx = {
		[styles.withVideo]: showVideo,
		[styles.withoutVideo]: _.isBoolean(showVideo) && !showVideo
	};
	const slidesCx = cx(styles.slides, videoCx);
	const slidersContainerCx = cx(styles.slidersContainer, videoCx);

	return (
		<div className={styles.recommendations}>
			<div className={styles.main}>
				<SwitchTransition>
					<Animation
						show
						key={activeEntity._id}
						addEndListener={(node, done) =>
							node.addEventListener('transitionend', done, false)
						}
						timeout={200}
						animation="fade"
					>
						{Preview && (
							<Preview
								key={activeEntity._id}
								data={activeEntity}
								onToggleVideo={setShowVideo}
								slidesClassName={slidesCx}
							/>
						)}
					</Animation>
				</SwitchTransition>
			</div>

			<div className={slidersContainerCx}>
				<RecommendationsSlider
					{...{
						activeEntity,
						setActiveEntity,
						entities: recommendations,
						markupBlocks,
						renderCard,
						title: 'Выбор редакции',
						setShowVideo,
						...props
					}}
				/>

				{!_(personalRecommendations).isEmpty() &&
					personalRecommendations?.length > 3 && (
						<RecommendationsSlider
							{...{
								activeEntity,
								markupBlocks,
								renderCard,
								entities: personalRecommendations,
								title: 'Персональные рекомендации',
								clickBehavior: 'link',
								...props
							}}
						/>
					)}
			</div>
		</div>
	);
};

Recommendations.propTypes = {
	recommendations: CommonPropTypes.entities.isRequired,
	type: PropTypes.oneOf(['broadcast', 'movies']).isRequired,
	renderCard: PropTypes.func.isRequired,
	personalRecommendations: CommonPropTypes.entities,
	title: PropTypes.string,
	markupBlocks: PropTypes.object
};

Recommendations.defaultProps = {
	title: 'Выбор редакции',
	markupBlocks: {}
};

export default Recommendations;
